<div class="u-paddingTop-16">
  <div
    *ngIf="account"
    class="u-paddingBottom-16 u-borderBottom-grey100 u-marginBottom-16"
  >
    <div
      class="u-marginBottom-16"
      fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="start center"
    >
      <app-avatar-account
        class="u-display-block"
        [item]="account"
        [size]="48"
      ></app-avatar-account>
    </div>
    <a
      class="u-display-block u-textDecoration-underline--hover text-subtitle-1"
      [routerLink]="['/profile', account.slug]"
    >
      <b class="color-black">{{ account.full_name }}</b>
      <span *ngIf="account.pronouns" class="color-grey-300">
        ({{ account.pronouns }})
      </span>
    </a>
    <p *ngIf="account.short_bio" class="color-grey-300">
      {{ account.short_bio }}
    </p>
    <a
      class="u-display-block color-grey-300"
      [routerLink]="['/profile', account.slug]"
      target="_blank"
      fxLayout="row"
      fxLayoutGap="4px"
      fxLayoutAlign="start center"
      [ngStyle]="{ marginTop: '4px' }"
    >
      <span i18n="@@accountEditDrawer.goToProfile">Go to profile</span>
      <mat-icon class="md-16">open_in_new</mat-icon>
    </a>
  </div>
  <div
    *ngIf="membership"
    class="u-borderRadius--4px u-border-grey100 u-padding-24"
  >
    <h6 class="u-marginBottom-16">{{ group.name }}</h6>
    <p
      class="text-subtitle-1 u-borderTop-grey100 u-paddingTop-16"
      i18n="@@accountEditDrawer.memberDetailsLabel"
    >
      Membership details
    </p>
    <div class="u-padding-16-0">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <p class="text-subtitle-2 u-marginBottom-8">Segments</p>
        <button
          class="c-button color-blue u-textDecoration-underline--hover"
          (click)="openMembershipDialog(account, group)"
          i18n="@@global.edit"
        >
          Edit
        </button>
      </div>
      <div fxLayout="row" fxLayoutGap="16px" class="u-marginBottom-8">
        <p
          class="color-grey-300 u-textTruncate"
          [ngStyle]="{ maxWidth: 'calc(50% - 8px)' }"
          i18n="@@global.role"
        >
          Role
        </p>
        <p class="u-textTruncate" [ngStyle]="{ maxWidth: 'calc(50% - 8px)' }">
          {{ membership.role | translationLookup: ['@@groupRole'] }}
        </p>
      </div>
      <div
        *ngFor="let segment of group.custom_segments"
        fxLayout="row"
        fxLayoutGap="16px"
        class="u-marginBottom-8"
      >
        <p
          class="color-grey-300 u-textTruncate"
          [ngStyle]="{ maxWidth: 'calc(50% - 8px)' }"
        >
          {{ segment.title | translationLookup: ['@@groupCustomSegmentTitle'] }}
        </p>
        <ng-container
          *ngIf="
            membership.segment_selections
              | getSegmentSelection: segment._id as selection
          "
        >
          <app-text-list
            *ngIf="selection"
            class="u-display-block"
            [list]="
              'multi' === segment.selection_type
                ? (selection.multiselected_nodes
                  | translationLookupList: ['@@groupCustomSegmentOption'])
                : (selection.node
                  | translationLookup: ['@@groupCustomSegmentOption'])
            "
          ></app-text-list>
          <p
            *ngIf="!selection"
            class="color-grey-300"
            i18n="@@accountEditDrawer.noSelection"
          >
            Not specified
          </p>
        </ng-container>
      </div>
    </div>
    <div
      *ngIf="hiddenSegmentsToDisplay?.length"
      class="u-padding-16-0 u-borderTop-grey100"
    >
      <app-private-segments-selections
        [account]="account"
        [user]="userState | async"
        [membership]="membership"
        class="u-display-block"
      ></app-private-segments-selections>
    </div>
    <div class="u-paddingTop-16 u-borderTop-grey100">
      <div
        class="u-marginBottom-8"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
          <p
            class="text-subtitle-2"
            i18n="@@accountEditDrawer.matchExclusionsLabel"
          >
            Match exclusions
          </p>
          <ng-container [ngSwitch]="isLoading">
            <mat-icon
              *ngSwitchCase="false"
              class="color-grey-300 md-16"
              nz-tooltip="Match exclusions prevent this account from being matched with other members who meet the following criteria via Introductions or Development Programs."
              i18n-nz-tooltip="@@accountEditDrawer.matchExclusionsTooltip"
              >info_outline
            </mat-icon>
          </ng-container>
        </div>
        <button
          *ngIf="!isLoading"
          class="c-button color-blue u-textDecoration-underline--hover"
          (click)="openMatchExclusionDrawer(account, group)"
          i18n="@@global.edit"
        >
          Edit
        </button>
      </div>
      <ng-container *ngIf="!isLoading; else loadingTemplate"
        ><app-match-exclusions-display
          class="u-display-block"
          [matchExclusions]="membership.match_exclusions"
        ></app-match-exclusions-display
      ></ng-container>
      <ng-template #loadingTemplate>
        <nz-skeleton
          [nzParagraph]="{ rows: 1, width: [300] }"
          [nzActive]="true"
        ></nz-skeleton>
      </ng-template>
    </div>
  </div>
</div>
<ng-template #exclusionChip let-name="name">
  <div
    class="u-border-grey100 u-borderRadius--4px text-caption u-marginBottom-8"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="4px"
    [ngStyle]="{ padding: '4px 8px' }"
  >
    <mat-icon class="md-18 color-orange">highlight_off</mat-icon>
    <span [ngStyle]="{ maxWidth: '200px' }" class="u-textTruncate">{{
      name
    }}</span>
  </div>
</ng-template>
